<template>
    <div class="box mb-4">
        <div class="box-header d-flex justify-content-between">
            <h5>{{ title }}</h5>
            <button type="button" class="btn btn-primary" @click="addAddress()">Add {{ title }}</button>
        </div>
        <div class="box-content">
            <div class="table-responsive">
                <div v-if="isLoading">Loading...</div>
                <table v-else class="table table-borderless">
                    <tbody v-if="addresses.length == 0">
                        <tr>
                            <td>No {{ title }}</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr v-for="(address, index) in addresses" :class="{'border-bottom': index != addresses.length - 1}">
                            <td class="pt-3">
                                <table>
                                    <tr>
                                        <td class="text-muted" align="right">Full Name:</td>
                                        <td class="font-16">
                                            <b>{{ address.full_name }}</b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td  class="text-muted"  align="right">Phone Number:</td>
                                        <td>{{ address.phone }}</td>
                                    </tr>
                                    <tr>
                                        <td  class="text-muted"  align="right">Address Line 1:</td>
                                        <td>{{ address.address_1 }}</td>
                                    </tr>
                                    <tr>
                                        <td  class="text-muted"  align="right">Address Line 2:</td>
                                        <td>{{ address.address_2 }}</td>
                                    </tr>
                                    <tr>
                                        <td  class="text-muted"  align="right">City:</td>
                                        <td>
                                            {{ address.city }}
                                            <span class="pl-5 text-muted">State: </span> {{ address.state }}
                                            <span class="pl-5 text-muted">Zip Code: </span> {{ address.zipcode }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td  class="text-muted  pb-3"  align="right">Country:</td>
                                        <td class="pb-3">{{ getCountryName(address.country) }}</td>
                                    </tr>
                                </table>
                            </td>
                            <td width="200" class="pt-3" align="right">
                                <button type="button" class="btn btn-sm btn-outline-primary mr-3" @click="editAddress(address)"><i class="icon-edit"></i> Edit</button>
                                <button type="button" class="btn btn-sm btn-outline-primary" @click=deleteAddress(address.id)><i class="icon-remove"></i> Delete</button>
                                <button type="button" :disabled="address.is_default == 1" class="btn btn-sm btn-outline-dark btn-block mt-2" @click=setDefaultAddress(address) style="width: 150px">Set default</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="modal" tabindex="-1" role="dialog" :id="`addressModal${type}`" v-if="currentAddress">
            <form @submit.prevent=saveAddress(currentAddress)>
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header border-0">
                            <h5 class="modal-title text-uppercase"><strong>{{ isEdit ? 'Edit' : 'Add New' }} {{ title }}</strong></h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Full name (*)</label>
                                        <input type="text" name="full_name" v-model="currentAddress.full_name" required="" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Country (*)</label>
                                        <select v-model="currentAddress.country" class="custom-select" required="">
                                            <option v-for="c in COUNTRY" :value="c.id">{{ c.name}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Address Line 1: (*)</label>
                                        <input type="text" name="address_1" v-model="currentAddress.address_1" required="" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Address Line 2:</label>
                                        <input type="text" name="address_2" v-model="currentAddress.address_2" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>City (*)</label>
                                        <input type="text" name="city" v-model="currentAddress.city" required="" class="form-control">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>State (*)</label>
                                        <select class="custom-select" v-model="currentAddress.state" required="" v-if="currentAddress.country == UNITED_STATES" >
                                            <option v-for="s in STATE" value="s.name">{{ s.name}}</option>
                                        </select>
                                        <input type="text" class="form-control" v-model="currentAddress.state" required="" v-else>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Zip Code (*)</label>
                                        <input type="text" name="zipcode" v-model="currentAddress.zipcode" required="" class="form-control">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-8">
                                    <div class="form-group">
                                        <label>Phone Number: (*)</label>
                                        <input type="text" name="phone" v-model="currentAddress.phone" required="" class="form-control">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer border-0">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button type="submit" class="btn btn-primary">Save</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {
    UNITED_STATES,
    COUNTRY,
    STATE
} from '../../constant.js'
export default {
    props: ['authToken', 'type'],
    data() {
        return {
            UNITED_STATES,
            COUNTRY,
            STATE,
            newAddress: {
                full_name: '', 
                country: UNITED_STATES,
                address_1: '', 
                address_2: '',
                city: '', 
                state: '', 
                zipcode: '', 
                phone: '', 
                is_default: 0,
                type: this.type
            },
            addresses: [],
            isLoading: false,
            title: '',
            currentAddress: this.newAddress,
            isEdit: false
        };
    },
    mounted() {
        this.title = this.type == 1 ? 'Billing Address' : 'Shipping Address';
        this.currentAddress = this.newAddress;
        this.getAddress();
    },
    methods: {
        async getAddress() {
            this.isLoading = true;
            const res = await axios.get(`/api/v1/address?type=${this.type}&auth_token=${this.authToken}`);
            if (res && res.data) {
                this.addresses = res.data.data;
            }
            this.isLoading = false;
        },
        addAddress() {
            this.isEdit = false;
            this.currentAddress = _.cloneDeep(this.newAddress);
            $(`#addressModal${this.type}`).modal('show');
        },
        editAddress(address) {
            this.isEdit = true;
            this.currentAddress =  _.cloneDeep(address);
            $(`#addressModal${this.type}`).modal('show');
        },
        async saveAddress(address) {
            const url = this.isEdit ? `/api/v1/update-address` : `/api/v1/address`;
            const res = await axios.post(`${url}?auth_token=${this.authToken}`, address);
            this.getAddress();
            $(`#addressModal${this.type}`).modal('hide');
        },
        async deleteAddress(id) {
            if (confirm('Are you sure to delete this address?')) {
                const res = await axios.post(`/api/v1/delete-address?id=${id}&auth_token=${this.authToken}`);
                this.getAddress();
            }
        },
        setDefaultAddress(address) {
            this.isEdit = true;
            address.is_default = !address.is_default;
            this.saveAddress(address);
        },
        getCountryName(id) {
            const country = _.find(COUNTRY, {'id': id});
            if (country && country.name) 
                return country.name;
            return '';
        }
    }
}
</script>
<style type="text/css" scoped>
    .table th, .table td {
        padding: 5px .75rem;
    }
</style>